// import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Login from './pages/Login';
// import OTP from './pages/OTP';
// import Dashboard from './pages/Dashboard';
// import Register from './pages/Register';
// import './styles/responsive.css';
// import LeadDetails from './components/LeadDetails/LeadDetails';

// const App: React.FC = () => {
//   return (
//     <Router>
//       <div className="App">
//         <Routes>
//           <Route path="/" element={<Login />} />
//           <Route path="/otp" element={<OTP />} />
//           <Route path="/register" element={<Register />} />
//           <Route path="/dashboard" element={<Dashboard />} />
//           <Route path="/lead/:id" element={<LeadDetails />} />

//         </Routes>
//       </div>
//     </Router>
//   );
// };

// export default App;
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import OTP from './pages/OTP';
import Dashboard from './pages/Dashboard';
import Register from './pages/Register';
import RegisterForm from "./pages/RegisterForm";
import LeadDetails from './components/LeadDetails/LeadDetails';
import RawLeadDetails from './components/LeadDetails/RawLeadDetails';
import PrivateRoute from './utils/PrivateRoute';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/otp" element={<OTP />} />
        <Route path="/register" element={<Register />} />
        <Route path="/register/form" element={<RegisterForm />} />

        {/* Protected Routes */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />

        <Route
          path="lead/:id"
          element={
            <PrivateRoute>
              <LeadDetails />
            </PrivateRoute>
          }
        />
         <Route
          path="rawlead/:id"
          element={
            <PrivateRoute>
              <RawLeadDetails />
            </PrivateRoute>
          }
        />
      </Routes>
      
    </Router>
  );
};

export default App;
